import { Modal, Icon } from "antd"
import { api, app } from "../../app"
import PayTemplate from "../../components/PayTemplate"
import React from "react"

const command = {

    /**
     * 省份数据
     */
    async provinceData () {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.MProvinceList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 无登录省份数据
     */
    async provinceDataNoToken () {
        let { flag, data, msg } = await app.post(api.DonateProvince)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 无登录队伍数据
     */
    async teamDataNoToken (province) {
        let { flag, data, msg } = await app.post(api.DonateTeam, { province })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 无登录用户数据
     */
    async userDataNoToken (teamno) {
        let { flag, data, msg } = await app.post(api.DonateUser, { teamno })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 队伍数据
     */
    async teamData (province) {
        const params = {
            province,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.provinceTeamListAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 队伍数据
     */
    async teamData2 (province) {
        const params = {
            province,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TProvinceTeamListAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 所有队伍数据
     */
    async teamAllData () {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TeamListAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 队员数据
     */
    async playerData (teamno) {
        const params = {
            teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.GetTeamUserAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 队员数据
     */
    async playerData2 (teamno) {
        const params = {
            teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TGetTeamUserAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 队员数据
     */
    async playerDataHT (teamno) {
        const params = {
            teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.GetTeamUserAllAdmid, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        return data
    },

    /**
     * 身份检查
     * @param sf
     * @returns {string}
     */
    checkSF (sf) {
        let str = ""
        switch (sf) {
            case "RZ"://队员
                str = "队员"
                break
            case "NORZ"://预备队员
                str = "预备队员"
                break
            case "PTZYZ"://志愿者
                str = "志愿者"
                break
            case "ZYZ"://认证志愿者
                str = "认证志愿者"
                break
            case "teamheader"://队长
                str = "队长"
                break
            case "administrator"://管理员
                str = "管理员"
                break
        }
        return str
    },


      /**
     * 选择出队队员
     * @param sf
     * @returns {string}
     */
      posseman (sf) {
        let str = ""
        switch (sf) {
            case "DY"://队员
                str = "队员"
                break
            case "YBDY"://预备队员
                str = "预备队员"
                break
            case "ZYZ"://志愿者
                str = "志愿者"
                break
            case "RZZYZ"://认证志愿者
                str = "认证志愿者"
                break
            case "teamheader"://队长
                str = "队长"
                break
            case "administrator"://管理员
                str = "管理员"
                break
        }
        return str
    },


    async trainPay (orders_no) {
        app.alert("正在跳转支付...", 'loading', '50%', 0)
        const params = {
            orders_no,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        const { flag, data, msg, is_free } = await app.post(api.TrainZhifu, params)
        if (flag === 1) {
            if (is_free) {
                app.alertDestroy()
                app.alert("报名成功~", 'success')
                let count = parseInt(app.getData('user_train_info_count'))
                if (!isNaN(count)) {
                    app.setData('user_train_info_count', count - 1)
                }
                return true
            } else {
                await app.sleep(1500)
                app.alertDestroy()
                window.location.href = data
            }
        } else {
            app.alert(msg, 'warn')
        }
        return false
    },

    /**
     * 培训支付
     * @param orders_no
     * @returns {Promise<void>}
     */
    trainPay2 (orders_no) {
        return new Promise(async (resolve) => {
            app.alert("正在加载支付...", 'loading', '45%', 0)
            const params = {
                orders_no,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            const { flag, data, msg, is_free } = await app.post(api.TrainZhifu, params)
            app.alertDestroy()
            if (flag === 1) {
                if (is_free) {
                    app.alert("报名成功~", 'success')
                    let count = parseInt(app.getData('user_train_info_count'))
                    if (!isNaN(count)) {
                        app.setData('user_train_info_count', count - 1)
                    }
                    resolve(true)
                } else {
                    Modal.confirm({
                        title: '扫码支付',
                        centered: true,
                        icon: (<Icon type="alipay-circle" style={{ color: '#00A1E9' }}/>),
                        width: 600,
                        content: (
                            <PayTemplate qrcode={data.qrUrl} money={data.totalAmount} no={data.orderCode}/>),
                        okText: '已支付',
                        cancelText: '关闭',
                        onOk: async () => {
                            const { flag, msg } = await app.post(api.TConfirmPay, {
                                indexno: app.getData('indexno'),
                                account: app.getData('account'),
                                order_code: data.orderCode
                            })
                            if (flag === 1) {
                                app.alert('支付成功', 'success')
                                resolve(true)
                                return true
                            } else {
                                app.alert(msg, 'warn')
                                resolve(false)
                                throw false
                            }
                        },
                        onCancel: () => {
                            resolve(false)
                        }
                    })
                }
            } else {
                app.alert(msg, 'warn')
                resolve(false)
            }
        })
    },

    /**
     * 不再显示通知或培训
     * @param id
     * @param type
     * @returns {Promise<boolean>}
     */
    async hideMessageOrTrain (id, type) {
        const params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let url = ''
        if (type === 'train') {
            url = api.TrainHideTrain
        } else if (type === 'message') {
            url = api.MessageHideMessage
        } else {
            throw '错误'
        }
        const { flag, msg } = await app.post(url, params)
        if (flag === 1) {
            app.alert('操作成功', 'success')
            return true
        } else {
            app.alert(msg, 'error')
            return false
        }
    }
}

export default command



// WEBPACK FOOTER //
// ./src/routes/notice/command.js